import React, {Component} from 'react';
import { Redirect } from 'react-router';
import MapContainer from "./MapaLocalizacao";

export class ExibeLocalizacaoCorpo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            radioValue: null,
            checkboxValue: [],
            redirect: false,
            errors : null,
            desabilitaBotao: false,
            id: this.props.id,
            txtConfirmar: "Confirmar",
            currentLocation: props.currentLocation,
        };
    }

    render() {

        if(this.state.redirect) {
            return <Redirect to={'/localizacaoEnviada'}/>
        }

        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <MapContainer id={this.props.id} currentLocation={this.props.currentLocation}/>
                </div>
            </div>
        );
    }
}
